import { render, staticRenderFns } from "./SearchField.vue?vue&type=template&id=48b22a30"
import script from "./SearchField.vue?vue&type=script&lang=js"
export * from "./SearchField.vue?vue&type=script&lang=js"
import style0 from "./SearchField.vue?vue&type=style&index=0&id=48b22a30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports